module.exports = __webpack_public_path__ + "1836f6eee70b614a9b94fb08e222014a.pdf";